<template>
    <div class="changePassWrapper">
        <div class="ui container">
            <div v-if="error" class="ui negative message">
                <div class="header">Link inválido</div>
                    <p>{{errorMsg}}</p>
            </div>
            <sui-segment v-if="!error" very padded>
                <div class="ui warning message">
                    <div class="header">Contraseña segura</div>
                    <p>Para mantener tu cuenta asegurada es necesario que actualices la contraseña cumpliendo las siguientes reglas:</p>
                    <ul>
                        <li>8 caracteres como mínimo</li>
                        <li>1 letra en mayuscula</li>
                        <li>1 letra en minuscula</li>
                        <li>1 Número mínimo</li>
                        <li>1 caracter mínimo. (Por ejemplo: @, !, ?, &, *, #, ", etc)</li>
                    </ul>
                </div>

                <sui-button class="right floated" primary @click="savePass">Guardar</sui-button>
                <sui-header dividing>Restablece tu contraseña</sui-header>
                <sui-form>
                    <sui-form-field>
                        <label>Usuario</label>
                        <input
                            disabled
                            :value="email"
                        />
                    </sui-form-field>
                    <sui-form-field>
                        <label>Nueva contraseña</label>
                        <input type="password" v-model="newPassword" />
                    </sui-form-field>
                    <sui-form-field>
                        <label>Confirmar contraseña nueva</label>
                        <input type="password" v-model="passwordConfirmation" />
                    </sui-form-field>
                </sui-form>
            </sui-segment>
        </div>
    </div>
</template>

<script>
import UserService from '@/services/UserService'

export default {
    name: 'ForgotPassword',
    data () {
        return {
            email: undefined,
            userId: undefined,
            id: '',
            loader: undefined,
            newPassword: undefined,
            passwordConfirmation: undefined,
            error: false,
            errorMsg: null
        }
    },
    async beforeMount () {
        this.id = this.$route.params.id
        this.loader = this.$loading.show()
        try {
            const valid = await UserService.resetPassword(this.$route.params.id, this.$route.params.token)
            if (valid) {
                this.email = valid.email
                this.userId = valid.id
                this.loader.hide()
            } else {
                this.errorMsg = 'Recuerda que el link tiene tiempo de vida de 15 minutos y es de un solo uso. Asegúrate de cambiar tu contraseña dentro de ese periodo y de que el link sea el correcto.'
                this.error = true
                this.loader.hide()
            }
        } catch (e) {
            this.errorMsg = 'Hubo un problema, por favor intenta más tarde.'
            this.error = true
            this.loader.hide()
        }
    },
    methods: {
        isValidPassword () {
            if (!this.newPassword) {
                this.$swal({
                    title: 'Las contraseña no puede estar vacía',
                    icon: 'error',
                    showCancelButton: false,
                    confirmButtonText: 'Aceptar',
                    confirmButtonColor: '#2BBA45',
                    showCloseButton: true
                })
                return false
            }

            if (this.newPassword.length < 8) {
                this.$swal({
                    title: 'La contraseña debe contener al menos 8 caracteres',
                    icon: 'error',
                    showCancelButton: false,
                    confirmButtonText: 'Aceptar',
                    confirmButtonColor: '#2BBA45',
                    showCloseButton: true
                })
                return false
            }

            if (!`${this.newPassword}`.match(/[A-Z]/g)) {
                this.$swal({
                    title: 'La contraseña debe contener al menos 1 letra en mayuscula',
                    icon: 'error',
                    showCancelButton: false,
                    confirmButtonText: 'Aceptar',
                    confirmButtonColor: '#2BBA45',
                    showCloseButton: true
                })
                return false
            }

            if (!`${this.newPassword}`.match(/[a-z]/g)) {
                this.$swal({
                    title: 'La contraseña debe contener al menos 1 letra en minuscula',
                    icon: 'error',
                    showCancelButton: false,
                    confirmButtonText: 'Aceptar',
                    confirmButtonColor: '#2BBA45',
                    showCloseButton: true
                })
                return false
            }

            if (!`${this.newPassword}`.match(/[0-9]/g)) {
                this.$swal({
                    title: 'La contraseña debe contener al menos 1 caracter especial',
                    icon: 'error',
                    showCancelButton: false,
                    confirmButtonText: 'Aceptar',
                    confirmButtonColor: '#2BBA45',
                    showCloseButton: true
                })
                return false
            }

            if (!`${this.newPassword}`.match(/\W/g)) {
                this.$swal({
                    title: 'La contraseña debe contener al menos 1 caracter especial',
                    icon: 'error',
                    showCancelButton: false,
                    confirmButtonText: 'Aceptar',
                    confirmButtonColor: '#2BBA45',
                    showCloseButton: true
                })
                return false
            }

            if ((!this.newPassword || !this.passwordConfirmation) || this.newPassword !== this.passwordConfirmation) {
                this.$swal({
                    title: 'Las contraseñas no coinciden',
                    icon: 'error',
                    showCancelButton: false,
                    confirmButtonText: 'Aceptar',
                    confirmButtonColor: '#2BBA45',
                    showCloseButton: true
                })
                return false
            }

            return true
        },
        async savePass () {
            if (!this.isValidPassword()) return

            this.loader = this.$loading.show()
            try {
                let updated = await UserService.saveUser({
                    userId: this.userId,
                    newPass: true,
                    pass: this.newPassword
                })
                if (updated) {
                    this.$swal({
                        title: 'Contraseña actualizada correctamente',
                        icon: 'success',
                        showCancelButton: false,
                        confirmButtonText: 'Iniciar sesión',
                        confirmButtonColor: '#2BBA45',
                        showCloseButton: true
                    }).then(async (result) => {
                        let routeData = this.$router.resolve({ name: 'login' })
                        window.open(routeData.href, '_self')
                    })
                }
                this.loader.hide()
            } catch (error) {
                this.loader.hide()
                console.error(error)
                this.$swal({
                    title: error.message,
                    icon: 'error',
                    showCancelButton: false,
                    confirmButtonText: 'Aceptar',
                    confirmButtonColor: '#2BBA45',
                    showCloseButton: true
                })
            }
        }
    }
}
</script>

<style scoped>
.loginWrapper {
    height: 100vh;
    align-content: center;
    display: grid;
    background: url(/pattern.png);
}
</style>
